"use client";
import CheckListCheck from "@/components/icons/CheckListCheck";
import { CardGridProps } from "../types";
import Image from "next/image";
import LinkWithChildren from "@/components/Link/LinkWithChildren/LinkWithChildren";
import { ElementType } from "@/constants/tagular/main";
import addWebviewLinkToCards from "@/components/CardGrid/utils/addWebviewLinkToCards";
import useWebview from "@/webview/useWebview";

export default function ProgramCards({ cards, title }: CardGridProps) {
  const { isWebview } = useWebview();
  let cardsToRender = isWebview ? addWebviewLinkToCards(cards) : cards;

  return (
    <>
      <p className="text-[22px] leading-[1.75rem] md:text-[32px] text-primary font-bold text-left mt-0 pt-0 mb-5 mb-sm-4">
        {title}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {cardsToRender.map((card, index) => (
          <LinkWithChildren
            item={card}
            index={index}
            location="programs"
            key={index}
            html_id="value-prop-card"
            class_name="overflow-hidden bg-primary text-white min-w-[221px] min-h-[244px] max-w-full sm:max-w-[466px] cursor-pointer rounded-[6px]"
            element_type={ElementType.Filter}
          >
            <div className="relative w-full h-6">
              <Image
                src={card.img!}
                alt={card.altText || ""}
                layout="fill"
                objectFit="cover"
              />
            </div>
            <p
              className="text-xl text-white font-semibold mb-0 mt-0"
              style={{
                padding: "16px 24px",
                fontSize: "22.4px",
                lineHeight: "28px",
              }}
            >
              {card.altText}
            </p>
            <div
              className="text-xs"
              style={{ padding: "0 24px 8px" }}
              dangerouslySetInnerHTML={{ __html: card.description! }}
            />
            <div style={{ padding: "0 12px 12px" }}>
              <ul>
                {card.checklist?.map((item, i) => (
                  <li key={i} className="flex items-center text-xs">
                    <CheckListCheck
                      svgProps={{
                        color: "#03C7E8",
                        width: "18px",
                        height: "16px",
                      }}
                    />
                    <span className="pl-1">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </LinkWithChildren>
        ))}
      </div>
    </>
  );
}
